export default __webpack_public_path__ + "static/media/modal_logo.41bdb2e2.png";